const consoleLogger = require('./client-logger'); // client 端使用的 logger

let defaultLogger = consoleLogger;

if (process.env.NEXT_PUBLIC_ENV !== 'development') {
  // 如果是本地开发环境，使用 consoleLogger
  if (typeof window === 'undefined') {
    defaultLogger = require('./server-logger'); // server 端使用的 logger
  }
}

module.exports = defaultLogger;
